import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
    },
    showPortalBarsOnFullScreen: {
      top: '50px',
      bottom: '50px',
    },
  };
};
